module.exports = __webpack_public_path__ + "static/7-3cae60bc22a6ab74e768c0aa9e2f1b22.jpg";